import { merge } from 'lodash';

import { sharedPrimitives } from '../shared/primitives';

const colorTokens = {
  'background-active': '#FF7D00',
  'background-badge': '#1F1F1F',
  'background-badge-rewards': '#911987',
  'background-badge-rewards-locked': '#F5F1EF',
  'background-button-primary-default': '#F25600',
  'background-button-primary-hover': '#BF4400',
  'background-button-primary-pressed': '#BF4400',
  'background-button-secondary-hover': '#F256001A',
  'background-button-secondary-pressed': '#F256001A',
  'background-checked': '#1F1F1F',
  'background-default': '#F5F1EF',
  'background-footer': '#1F1F1F',
  'background-hero-light': '#FFFFFF',
  'background-hero-reversed': 'radial-gradient(50% 266.27% at 50% 50%, #FF7D00 0%, #F25600 100%)',
  'background-loader-indicator-primary': '#F25600',
  'background-skeleton-loader-cta-start': '#F6CEBA',
  'background-skeleton-loader-cta-end': '#F256001A',
  'background-switch-track': '#1F1F1F',
  'border-color-active': '#FF7D00',
  'border-color-badge': '#1f1f1f',
  'border-color-button-secondary': '#F25600',
  'border-color-checked': '#1F1F1F',
  'border-color-focus': '#1F1F1F',
  'border-color-hover': '#1F1F1F',
  'icon-active': '#FF7D00',
  'icon-button-primary-reversed': '#1F1F1F',
  'icon-button-secondary': '#F25600',
  'icon-button-tertiary-default': '#1F1F1F',
  'icon-button-tertiary-hover': '#F25600',
  'icon-button-tertiary-pressed': '#F25600',
  'icon-default': '#1F1F1F',
  'icon-form-input-action': '#1F1F1F',
  'icon-reversed': '#FFFFFF',
  'icon-rewards': '#1F1F1F',
  'icon-rewards-locked': '#FFFFFF',
  'text-active': '#F25600',
  'text-button-primary-reversed': '#1F1F1F',
  'text-button-secondary': '#F25600',
  'text-button-tertiary-default': '#1F1F1F',
  'text-button-tertiary-hover': '#F25600',
  'text-default': '#1F1F1F',
  'text-hero-light': '#1F1F1F',
  'text-link-default': '#1F1F1F',
  'text-link-hover': '#F25600',
  'text-link-reversed': '#FFFFFF',
  'text-reversed': '#FFFFFF',
  'text-rewards': '#1F1F1F',
  'text-rewards-locked': '#FFFFFF',
};

// @todo update with color from Design
// http://mcg.mbitson.com/#!?plk=%23f25600&bk=%23502314&th=%23c8102e&themename=mcgtheme
// Based on popeyesOrange
const primary = {
  50: '#fdebe0',
  100: '#fbccb3',
  200: '#f9ab80',
  300: '#f6894d',
  400: '#f46f26',
  500: '#f25600',
  600: '#f04f00',
  700: '#ee4500',
  800: '#ec3c00',
  900: '#e82b00',
};

// Based on secondary color from the CL
const secondary = {
  50: '#ebe6e6',
  100: '#cdc0c0',
  200: '#ab9696',
  300: '#896c6c',
  400: '#704d4d',
  500: '#572d2d',
  600: '#4f2828',
  700: '#462222',
  800: '#3c1c1c',
  900: '#2c1111',
};

// Based on nolaTeal
const tertiary = {
  50: '#e0f4f3',
  100: '#b3e4e2',
  200: '#80d3cf',
  300: '#4dc1bb',
  400: '#26b3ad',
  500: '#00a69e',
  600: '#009e96',
  700: '#00958c',
  800: '#008b82',
  900: '#007b70',
};
// /@todo

export const plkPrimitives = merge({}, sharedPrimitives, {
  colors: {
    primary,
    secondary,
    tertiary,
    nolaDark: '#1F1F1F',
    nolaLight: 'rgb(245,241,239)',
    popeyesOrange: '#F25600',
    burntOrange: '#F25600',
    nolaTeal: 'rgb(0,166,158)',
    nolaPurple: 'rgb(145,25,135)',
    butterYellow: 'rgb(255,200,0)',
    spicyRed: 'rgb(217,15,6)',
    burntOrangeOpacity10: 'rgba(242,86,0,0.1)',
    burnOrangeDarken10: 'rgb(191,86,0)',
    token: colorTokens,
  },
  fontConfig: {
    'Chicken-Sans': {
      400: {
        normal: 'Chicken-Sans-Regular',
        // There is no italic version of this font
        // Setting to the same as normal so that we don't break iOS
        italic: 'Chicken-Sans-Regular',
      },
      700: {
        normal: 'Chicken-Sans-Bold',
        // There is no italic version of this font
        // Setting to the same as normal so that we don't break iOS
        italic: 'Chicken-Sans-Bold',
      },
    },
    'Chicken-Sans-Bold': {
      // Force bold font regardless of what font-weight is set
      400: {
        normal: 'Chicken-Sans-Bold',
        // There is no italic version of this font
        // Setting to the same as normal so that we don't break iOS
        italic: 'Chicken-Sans-Bold',
      },
      700: {
        normal: 'Chicken-Sans-Bold',
        // There is no italic version of this font
        // Setting to the same as normal so that we don't break iOS
        italic: 'Chicken-Sans-Bold',
      },
    },
  },
  fonts: {
    heading: 'Chicken-Sans',
    body: 'Chicken-Sans',
    alternative: 'Chicken-Sans-Bold',
  },
} as const);
